<script setup lang="ts">
import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";
import { openVIP } from "@/components/Dialogues/useData/useDialogues";
const { isLogin, vipDisplay } = storeToRefs(publicStore());
import { isCompactMode } from "@/data/pubilc";
import { openLoginDialog } from "@/components/Dialogues/useData/login";
</script>

<template>
  <div class="btn-base">
    <div
      class="vip"
      v-if="isLogin"
      @click="openVIP"
      :class="{
        'vip-moile': isCompactMode,
      }"
    >
      <img class="vip-icon" src="@/assets/vip.png" alt="" srcset="" />
      <div v-if="!isCompactMode">{{ vipDisplay }}</div>
    </div>
    <div class="login" v-else @click="openLoginDialog">
      <el-icon :size="26"><UserFilled /></el-icon>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.btn-base {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .login {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 1px solid #2c3e50;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: #2c3e5033;
    }
  }

  .vip {
    width: auto;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    border-radius: 17px;
    gap: 8px;
    color: #4d6bfe;
    font-size: 14px;
    background: #dbeafe;
    &:hover {
      background-color: #dbeafe55;
    }
  }
  .vip-moile {
    width: 34px;
    background-color: #fff;
  }
}

.vip-icon {
  width: 20px;
  height: 16px;
}
</style>
